import { create } from "zustand";
import { ScrollRefState } from "../types";

/**
 * Scroll ref store for managing scroll references
 * This store is not persisted as it's temporary state
 */
const useScrollRefStore = create<ScrollRefState>()((set) => ({
  ref: null,
  setRef: (ref) => set({ ref }),
}));

export default useScrollRefStore;
